module.exports = __webpack_public_path__ + "static/media/JM_iconos-02_favorito_act-blue.3234519b.svg";